import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';

/**
 * Yoco cancel landing page — reached when a customer aborts the hosted checkout.
 * No order-status polling here because "cancelled" is the terminal state for this URL;
 * if the customer ends up completing later via retry, the /payment-success page handles it.
 */
export const YocoPaymentCancelled = () => {
  const [params] = useSearchParams();
  const orderId = params.get('order_id');
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center py-16 px-6">
      <div className="max-w-md text-center">
        <XCircle className="w-16 h-16 mx-auto mb-6 text-muted" strokeWidth={1.5} />
        <div className="caps text-muted mb-3" data-testid="yoco-cancel-status">Payment cancelled</div>
        <h1 className="font-serif text-4xl md:text-5xl mb-4" data-testid="yoco-cancel-title">
          No <em className="italic">charge.</em>
        </h1>
        {orderId && (
          <p className="text-muted mb-2">Order <span className="font-mono text-ink">{orderId}</span></p>
        )}
        <p className="text-muted mb-8">Your payment was cancelled and nothing was charged. Feel free to try again whenever you&apos;re ready.</p>
        <div className="flex gap-3 justify-center">
          <button onClick={() => navigate(-1)} className="btn-editorial btn-ghost border-l" style={{ borderLeft: '1px solid rgba(17,17,16,0.85)' }} data-testid="yoco-cancel-back-btn">
            Try again
          </button>
          <button onClick={() => navigate('/')} className="btn-editorial btn-solid" data-testid="yoco-cancel-home-btn">
            Back to home →
          </button>
        </div>
      </div>
    </div>
  );
};
